import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

let state = {
  account: {
    firstName: '',
    lastName: '',
    email: '',
    lastLoginDate: '',
    role: '',
    companyName: '',
    companyId: '',
  },
  apikey: '',
  isLogged: false,
  language: 'FR-fr',
  newPasswordVerificationToken: null,
  expiredPassword: false,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
